const NY_TZ = 'America/New_York';

// Returns YYYY-MM-DD in New York time — independent of the browser's local timezone.
export function toNYDate(d = new Date()) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: NY_TZ }).format(d);
}

// Format a UTC ISO timestamp for display in New York time.
export function formatNY(isoStr) {
  return new Date(isoStr).toLocaleString('en-US', { timeZone: NY_TZ });
}

export function today() {
  const d = toNYDate();
  return { start: d, end: d };
}

export function yesterday() {
  const now = new Date();
  now.setDate(now.getDate() - 1);
  const s = toNYDate(now);
  return { start: s, end: s };
}

export function thisMonth() {
  const nyToday = toNYDate();
  const [year, month] = nyToday.split('-');
  return { start: `${year}-${month}-01`, end: nyToday };
}

export const PRESETS = [
  { key: 'today',     label: 'Today',      get: today },
  { key: 'yesterday', label: 'Yesterday',  get: yesterday },
  { key: 'month',     label: 'This Month', get: thisMonth },
];
